import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class GanjikaBeveragePrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.NeueHaasGroteskDisplay.Regular_400, FONT.NeueHaasGroteskDisplay.Medium_500];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/wpu2ils.css';
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
